import { suppressResizeObserverLoopError } from './shared/utils/suppressResizeObserverLoopError';

suppressResizeObserverLoopError();
